export function schema_magick_convert() {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			options: {
				title: "Options - https://imagemagick.org/script/convert.php",
				type: "array",
				format: "table",
				items: {
					title: "option",
					type: "string"
				}
			},
			prefix: {
				title: "Préfixe",
				type: "string"
			},
			sufix: {
				title: "Suffixe",
				type: "string"
			},
			extension: {
				title: "Nouvelle extension du fichier",
				type: "string"
			},
			column_url: {
				title: "csv - colonne des urls",
				type: "string"
			},
			column_name: {
				title: "csv - colonne des noms des fichiers",
				type: "string"
			},
			column_url_result: {
				title: "csv - colonne des urls de résultats",
				type: "string"
			},
			column_name_result: {
				title: "csv - colonne des noms des fichiers de résultat",
				type: "string"
			},
		},
	};
}
